export var GRID_GUTTER = {
  xs: 16,
  lg: 24
};
export var GRID_SPACING = 0;
export var GRID_COLUMNS = 12;